$(function(){
    $('.container_tab section.topInfo:nth-child(4n+2)').each(function(){
        $(this).css({borderRight: 'none' , marginRight:'0' , paddingRight:'0'});
    })

	// ピンポイント検索
	$("input#rent_min").val("");
	$("input#rent_max").val("");
	$("input#layout").val("");

	// 賃料を設定する
	$("ul#rent_select a").click(function(){
		$("input#rent_min").val("");
		$("input#rent_max").val("");
		if ($(this).attr("value") != "")
		{
			var parms = $(this).attr("value").split( ',' );
			if (parms.length == 1)
				{
					$("input#rent_min").val(parms[0]);
				}
			else
				{
					$("input#rent_min").val(parms[0]);
					$("input#rent_max").val(parms[1]);
				}
		};
		return false;
	});
	// 間取りを設定する
	$("ul#room_select a").click(function(){
		$("input#layout").val($(this).attr("value"));
		return false;
	});

	// タブ切り替えのスクリプトによってdisplay:noneにされてしまうので
	// 表示しておく
	$("#top .container_tab div section div").show();

	// 物件画像 遅延読込
	$("img.lazy").lazyload({
		effect: 'fadeIn',
		effectspeed: 500,
		event: 'showLazyImage',
	});
	// tabがクリックされたときに画像の遅延読込
	$('.btn_tab li a').on('click', function(){
		var tabLength = $(this).parent().index()+1;
		tabLength = "#tab" + tabLength;
		$(tabLength).find('img.lazy').trigger('showLazyImage');
	});
	// スクロール時、表示されている画像の遅延読込
	$(window).on('scroll', function(){
		$('img.lazy:visible').trigger('showLazyImage');
	});
});
